import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MxMaterialModule} from '../../material/mx-material.module';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxFormModule} from '../mx-form/mx-form.module';
import {MxGridModule} from '../mx-grid/mx-grid.module';
import {MxReportViewComponent} from './mx-report-view/mx-report-view.component';

@NgModule({
    imports: [
        CommonModule,
        MxMaterialModule,
        MxButtonModule,
        MxFormModule,
        MxGridModule
    ],
    exports: [
        MxReportViewComponent
    ],
    declarations: [
        MxReportViewComponent
    ]
})
export class MxReportViewModule { }
